import styled from "styled-components"

export const HorizontalRule = styled.hr.attrs({ "aria-hidden": "true" })`
  height: 1px;
`
